/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol/Changelog/SingleChangelog";
export const meta = {
  id: 68,
  image: "default-changelog-v2.png",
  title: "Fizz Nodes Upgrades, including Multi-GPU support and Node Isolation Setup & Security, New Community Flow on GPU Marketplace and key protocol fixes",
  shortDescription: "Enhanced Fizz Nodes with multi-GPU support, Node Isolation setup, faster deployments, and improved monitoring; added VRAM checks, real-time leaderboard, and Secure & Community filters in the GPU marketplace; improved protocol stability with better error handling, pricing fixes, and deployment reliability.",
  description: "Enhanced Fizz Nodes with multi-GPU support, Node Isolation setup, faster deployments, and improved monitoring; added VRAM checks, real-time leaderboard, and Secure & Community filters in the GPU marketplace; improved protocol stability with better error handling, pricing fixes, and deployment reliability.",
  date: "April 4th, 2025",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Spheron", "Base Sepolia", "AI Agents", "AI", "GPU", "Compute", "Protocol", "Fizz Node", "Gateway", "Spheron Light Node", "CLI", "ICL", "Provider", "Smart Contract", "L3 chain", "Ethereum", "Testnet", "updates"]
};
export const content = `
This release introduces several important improvements across node functionality, user experience, deployment reliability, and protocol-level operations. We've focused on increasing node flexibility, improving deployment speed and stability, and ensuring a more consistent and secure experience for both node operators and users.

**Node Capabilities & Performance Improvements**
------------------------------------------------

### **Multi-GPU Support**

Fizz nodes now support multiple GPUs of the same type. Users can configure the number of GPUs used during setup. This removes the previous fixed GPU limitation and allows operators with larger setups to fully utilize their hardware.

_Note: Mixed GPU models (e.g., combining RTX 4090 and RTX 3090) are not supported to maintain consistent performance._

### **Improved Node Isolation & Security**

We've added an additional isolation module that enhances container separation and resource control. This not only strengthens security but also reduces the likelihood of system conflicts and supports more predictable performance.

### **Resource and Bandwidth Adjustments**

*   CPU and memory limits on Fizz nodes have been removed, allowing more flexible and dynamic resource usage during deployments.
    
*   Bandwidth bidding has been corrected based on the actual bandwidth attribute from the ICL, ensuring more accurate network matching.
    

### **Speed Test Optimization**

The speed test module has been restructured into a standalone container. This ensures it no longer consumes memory unnecessarily or interferes with node performance, particularly during garbage collection.

**Deployment Enhancements & Developer Experience**
--------------------------------------------------

### **Pre-Downloaded Common Images**

Popular tools such as Jupyter, VSCode, and Ollama are now bundled as pre-downloaded images. This leads to significantly faster deployment times for common workloads.

### **Enhanced Logging & Monitoring**

*   Docker pull logs have been cleaned up to reduce noise and provide more useful information.
    
*   The logging system has been upgraded for better context management and deeper integration with BetterStack telemetry.
    
*   Log level controls have been added, giving operators more flexibility in monitoring node activity.
    

### **Deployment Safety Controls**

Workloads will no longer be deployed on nodes that have been flagged for issues, ensuring higher deployment reliability and protecting user workloads from being assigned to unreliable operators.

### **Docker Credential Support**

Fizz start commands now support passing Docker credentials (username and password). This allows users with private DockerHub images or quota limits to deploy without hitting rate restrictions.

**GPU Marketplace & Community Access**
--------------------------------------

### **New Community Flow**

We've introduced a new deployment flow in the GPU Marketplace. Users can now select between:

*   **Community-operated Fizz nodes** at a lower cost
    
*   **Secure data center-grade providers** for more stability and performance guarantees
    

### **New Deployment Templates**

*   **WAN 2.1 Web UI**
    
*   **Stable Diffusion (Ultra Realistic)**
    

These templates make it easier for users to launch commonly used AI and model workflows with minimal configuration.

**Protocol-Level Changes & Fixes**
----------------------------------

### **Version Compliance Requirements**

Minimum supported versions are now enforced:

*   Fizz Node: **v1.3.3**
    
*   CLI: **v1.6.0**
    

Nodes running older versions will no longer accrue reward points. This ensures compatibility and consistent performance across the network.

### **Slark Node Monitoring Enhancements**

Slark nodes now perform average VRAM availability checks. Nodes with VRAM below 75% will be penalized and flagged for review on the My Fizz dashboard.

**Deployment Reliability & Pricing Accuracy**

*   Retry logic has been added for image pulling during deployment, reducing failure rates.
    
*   Fallback mechanisms now clean up stale deployments more effectively.
    
*   Pricing logic has been updated to ensure accurate billing for both Fizz and provider modes.
    

**Reward & Leaderboard Fixes**

The leaderboard now reflects real-time reward points for connected Fizz nodes, shown at the top of the table.
`;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
